import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 1.0;
const DEFAULT_HEIGHT = 1.0;

const Shower: C1_FurnitureDefinition = {
  id: "shower",
  icon: <C1_FurnitureIcon kind="shower" />,
  description: { en: "Shower", de: "Dusche" },
  category: RoomType.Bathroom,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  autoRotate: true,
  autoReflect: true,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const inset = 0.02 * PX;
    const detailInset = Math.min(0.1 * PX, width * 0.2, height * 0.2);

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={0}
        originYPercentage={0}
      >
        <g transform={`translate(${width} 0) scale(-1 1)`}>
          <rect
            x={inset}
            y={inset}
            width={Math.max(0, width - inset * 2)}
            height={Math.max(0, height - inset * 2)}
            rx={Math.min(0.04 * PX, width / 2, height / 2)}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
          {showDetails && (
            <>
              <line x1={detailInset} y1={detailInset} x2={width - detailInset} y2={height - detailInset} stroke={finalStrokeColor} strokeWidth={finalStrokeWidth} />
              <line x1={width - detailInset} y1={detailInset} x2={detailInset} y2={height - detailInset} stroke={finalStrokeColor} strokeWidth={finalStrokeWidth} />
              <circle cx={width / 2} cy={height / 2} r={Math.min(0.05 * PX, width * 0.08, height * 0.08)} fill="none" stroke={finalStrokeColor} strokeWidth={finalStrokeWidth} />
            </>
          )}
        </g>
      </C1_FurnitureSvg>
    );
  },
};

export default Shower;
